module.exports = __webpack_public_path__ + "media/images/icon/icons8-Checked Checkbox-b3405e58b4b631a9fe55134d3b41a6d7.png";